import React from "react";
import "./Pages.css";

function NotFound() {
  return (
    <div className="not-found">
      <div className="error-code">404</div>
      <div className="error-divider"></div>
      <h1>Page Not Found</h1>
      <p>The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
      <a href="/">Return Home</a>
    </div>
  );
}

export default NotFound;